export default __webpack_public_path__ + "static/media/placeholder_business05-fr-mobile.89d54dc1.png";